export enum ROLE {
  ADMIN = 'admin',
  USER = 'user'
}
